import { useTranslation } from 'react-i18next';
import { SlidersHorizontalIcon } from 'lucide-react';
import { Button } from '@noor/ui';
import { useModalStore } from '@noor/lib';
import { Can } from '@/entities/access';

/**
 * Opens the status-priority reorder dialog. Rendered in the CURRENT-tab toolbar.
 * `withLabel` shows a full labeled button; otherwise a compact icon button.
 */
export function StatusPriorityButton({ withLabel = false }: { withLabel?: boolean }) {
  const { t } = useTranslation('orders');
  const openModal = useModalStore((s) => s.openModal);

  if (withLabel) {
    return (
      <Can permission="orders.priority.manage">
        <Button
          variant="soft"
          shape="rounded"
          size="modal"
          onClick={() => openModal('status-priority', {})}
        >
          <SlidersHorizontalIcon className="size-4" />
          {t('priority.title')}
        </Button>
      </Can>
    );
  }

  return (
    <Can permission="orders.priority.manage">
      <Button
        variant="ghost"
        size="icon"
        className="size-6"
        aria-label={t('priority.title')}
        title={t('priority.title')}
        onClick={() => openModal('status-priority', {})}
      >
        <SlidersHorizontalIcon className="size-3.5" />
      </Button>
    </Can>
  );
}
